<template>
  <div class="limiter">
    <div class="image">
      <img src="@/assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100">
      <div class="wrap-login100">

        <div class="form-summary">
          <h2 style="color: #3A6898">Stock Details</h2>
          <div class="form-group">
            <p class="summary-item"><strong>Name:</strong></p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>POU:</strong> </p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>Description:</strong> </p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>Quantity:</strong> </p>
          </div>
          <button class="login100-form-btn" @click="confirmAndUpdateState('ready', 'STAFF')">
            Pick Item
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      state: 'picked' // Initial state
    };
  },
  methods: {
    async confirmAndUpdateState(newState, label) {
      const result = await Swal.fire({
        title: `Has the ${label} picked the Stocked?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      });

      if (result.isConfirmed) {
        await this.updateState(newState);
      }
    },

    async updateState(state) {
      try {
        const urlId = 'example-url-id';
        await axios.post('/api/update-url-state', { urlId, state });
        console.log('URL state updated to:', state);
        this.state = state; // Update the state in the component
      } catch (error) {
        console.error('Failed to update URL state:', error);
      }
    }
  }
}
</script>
